// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Poppins', sans-serif;
}
.container2 {
    text-align: center;
    
  }
.section-services {
    transition: all 0.7s linear;
  }
  
  .section-services p {
    max-width: 60rem;
    text-align: center;
  }
  .section-services h3{
   
    text-align: center;
  }

  .grid-three-column {
    grid-template-columns: repeat(3, 1fr);
    /* grid-template-columns: 1fr 1fr; */
   
  

  }
  .section-services .grid {
    margin-top: 0.2rem;
    row-gap: 1rem;
  
  }
  
  .service-box {
    text-align: center;
    border-radius: 5px;
    padding: 3rem 3.4rem;
    box-sizing: border-box;
    transition: all 0.2s linear;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  }
  
  .service-box:hover,
  .service-box:active {
    transform: translateY(-3rem);
  }
  
  .service-icon {
    width: 5rem;
    height: 5rem;
    background-color: #fff;
    display: inline-block;
    padding: 1.4rem 1.8rem;
    position: relative;
    color: var(--heading);
    animation: 3s linear infinite;
  }
  
  .service-icon::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;
    background: transparent;
    border: 1px solid var(--black);
  }
  
  .service-box h3 {
    text-transform: capitalize;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

@media only screen and (max-width: 1000px) {
   .grid-three-column{  grid-template-columns: repeat(1, 1fr);}
  
   .service-box{
      width: 100%;
   }
  
     }

     @media only screen and (max-width: 430px) {
      .section-services {
        padding: 1rem; /* Adjust the padding for smaller screens */
      }
    
      .common-heading {
        font-size: 3vw; /* Adjust the font size for the heading */
      }
    
      .lead {
        font-size: 1.2vw; /* Adjust the font size for the lead text */
      }
    
      .grid-three-column {
        grid-template-columns: repeat(1, 1fr);
        gap: 1rem; /* Adjust the gap between service boxes */
      }
    
      .service-box {
        padding: 1rem; /* Adjust the padding for service boxes */
        text-align: center;
      }
    
      /* Adjust other styles as needed for screens up to 430px */
    }
    @media only screen and (max-width: 240px) {
      .section-services {
        padding: 0.1rem; /* Adjust the padding for smaller screens */
      }
    
      .common-heading {
        font-size: 2vw; /* Adjust the font size for the heading */
      }
    
      .lead {
        font-size: 0.5vw; /* Adjust the font size for the lead text */
      }
    
      .grid-three-column {
        grid-template-columns: repeat(1, 1fr);
        gap: 0.5rem; /* Adjust the gap between service boxes */
      }
    
      .service-box {
        padding: 0.1rem; /* Adjust the padding for service boxes */
        text-align: center;
      }
    
      /* Adjust other styles as needed for screens up to 430px */
    }`, "",{"version":3,"sources":["webpack://./src/components/features.css"],"names":[],"mappings":"AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;;EAEpB;AACF;IACI,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oCAAoC;;;;EAItC;EACA;IACE,kBAAkB;IAClB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;GACG,qBAAqB,qCAAqC,CAAC;;GAE3D;MACG,WAAW;GACd;;KAEE;;KAEA;MACC;QACE,aAAa,EAAE,2CAA2C;MAC5D;;MAEA;QACE,cAAc,EAAE,yCAAyC;MAC3D;;MAEA;QACE,gBAAgB,EAAE,2CAA2C;MAC/D;;MAEA;QACE,qCAAqC;QACrC,SAAS,EAAE,yCAAyC;MACtD;;MAEA;QACE,aAAa,EAAE,yCAAyC;QACxD,kBAAkB;MACpB;;MAEA,0DAA0D;IAC5D;IACA;MACE;QACE,eAAe,EAAE,2CAA2C;MAC9D;;MAEA;QACE,cAAc,EAAE,yCAAyC;MAC3D;;MAEA;QACE,gBAAgB,EAAE,2CAA2C;MAC/D;;MAEA;QACE,qCAAqC;QACrC,WAAW,EAAE,yCAAyC;MACxD;;MAEA;QACE,eAAe,EAAE,yCAAyC;QAC1D,kBAAkB;MACpB;;MAEA,0DAA0D;IAC5D","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap');\r\n*{\r\n    font-family: 'Poppins', sans-serif;\r\n}\r\n.container2 {\r\n    text-align: center;\r\n    \r\n  }\r\n.section-services {\r\n    transition: all 0.7s linear;\r\n  }\r\n  \r\n  .section-services p {\r\n    max-width: 60rem;\r\n    text-align: center;\r\n  }\r\n  .section-services h3{\r\n   \r\n    text-align: center;\r\n  }\r\n\r\n  .grid-three-column {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    /* grid-template-columns: 1fr 1fr; */\r\n   \r\n  \r\n\r\n  }\r\n  .section-services .grid {\r\n    margin-top: 0.2rem;\r\n    row-gap: 1rem;\r\n  \r\n  }\r\n  \r\n  .service-box {\r\n    text-align: center;\r\n    border-radius: 5px;\r\n    padding: 3rem 3.4rem;\r\n    box-sizing: border-box;\r\n    transition: all 0.2s linear;\r\n    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);\r\n  }\r\n  \r\n  .service-box:hover,\r\n  .service-box:active {\r\n    transform: translateY(-3rem);\r\n  }\r\n  \r\n  .service-icon {\r\n    width: 5rem;\r\n    height: 5rem;\r\n    background-color: #fff;\r\n    display: inline-block;\r\n    padding: 1.4rem 1.8rem;\r\n    position: relative;\r\n    color: var(--heading);\r\n    animation: 3s linear infinite;\r\n  }\r\n  \r\n  .service-icon::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 90%;\r\n    height: 90%;\r\n    background: transparent;\r\n    border: 1px solid var(--black);\r\n  }\r\n  \r\n  .service-box h3 {\r\n    text-transform: capitalize;\r\n    margin-top: 2rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n@media only screen and (max-width: 1000px) {\r\n   .grid-three-column{  grid-template-columns: repeat(1, 1fr);}\r\n  \r\n   .service-box{\r\n      width: 100%;\r\n   }\r\n  \r\n     }\r\n\r\n     @media only screen and (max-width: 430px) {\r\n      .section-services {\r\n        padding: 1rem; /* Adjust the padding for smaller screens */\r\n      }\r\n    \r\n      .common-heading {\r\n        font-size: 3vw; /* Adjust the font size for the heading */\r\n      }\r\n    \r\n      .lead {\r\n        font-size: 1.2vw; /* Adjust the font size for the lead text */\r\n      }\r\n    \r\n      .grid-three-column {\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 1rem; /* Adjust the gap between service boxes */\r\n      }\r\n    \r\n      .service-box {\r\n        padding: 1rem; /* Adjust the padding for service boxes */\r\n        text-align: center;\r\n      }\r\n    \r\n      /* Adjust other styles as needed for screens up to 430px */\r\n    }\r\n    @media only screen and (max-width: 240px) {\r\n      .section-services {\r\n        padding: 0.1rem; /* Adjust the padding for smaller screens */\r\n      }\r\n    \r\n      .common-heading {\r\n        font-size: 2vw; /* Adjust the font size for the heading */\r\n      }\r\n    \r\n      .lead {\r\n        font-size: 0.5vw; /* Adjust the font size for the lead text */\r\n      }\r\n    \r\n      .grid-three-column {\r\n        grid-template-columns: repeat(1, 1fr);\r\n        gap: 0.5rem; /* Adjust the gap between service boxes */\r\n      }\r\n    \r\n      .service-box {\r\n        padding: 0.1rem; /* Adjust the padding for service boxes */\r\n        text-align: center;\r\n      }\r\n    \r\n      /* Adjust other styles as needed for screens up to 430px */\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
